import React, { FC, Fragment } from 'react';
import * as icons from '@maas-components/icons';
import { useTheme, useMediaQuery, Box, Chip, Typography } from '@maas-components/core';
import useStyles from './styles';
import { Icon, Service } from '../../../types';

type SearchItemProps = {
    service: Service;
    onClick: (service: string) => void;
    mode: 'dark' | 'light';
    RouterLink?: React.ElementType;
};

const SearchItem: FC<SearchItemProps> = ({ service, onClick, mode, RouterLink }) => {
    const classes = useStyles({ mode });
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const getIcon = (iconName: Icon) => {
        const IconWrapper = icons[iconName] || icons.DashboardOutlined;
        return <IconWrapper fontSize="small" />;
    };

    const renderContentItem = () => (
        <Fragment>
            <Box display="flex" justifyContent="center" alignItems="center">
                {getIcon(service.icon)}
                {!isMobile && service.isNew && (
                    <Box ml={1}>
                        <Chip size="small" label="Novo" className={classes.newChip} />
                    </Box>
                )}
            </Box>
            <Typography align="center">{service.name}</Typography>
            {isMobile && service.isNew && (
                <Box ml={1}>
                    <Chip size="small" label="Novo" className={classes.newChip} />
                </Box>
            )}
        </Fragment>
    );

    const renderContent = () => {
        if (RouterLink && !service.external) {
            return (
                <RouterLink className={classes.searchItem} to={service.url} onClick={() => onClick(service.name)}>
                    {renderContentItem()}
                </RouterLink>
            );
        }

        return (
            <a className={classes.searchItem} href={service.url} onClick={() => onClick(service.name)}>
                {renderContentItem()}
            </a>
        );
    };

    return (
        <Box display="flex" flexDirection="column" justifyContent="flex-start" className={classes.searchItemContainer}>
            {renderContent()}
        </Box>
    );
};

export default SearchItem;
